import { PhongSettings } from '@technology/web3d';
import type { ViewerPreferenceMaterialPhong } from '@trimble/viewer-preferences';

export const viewerPreferenceMaterialPhong: ViewerPreferenceMaterialPhong = {
  dark: PhongSettings.DarkMode,
  default: PhongSettings.Default,
};
